var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEditCupom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.794,
  height: 17.22,
  viewBox: "0 0 16.794 17.22",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_9198",
  "data-name": "Grupo 9198",
  transform: "translate(0.506 0.663)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_841",
  "data-name": "Grupo 841",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_834",
  "data-name": "Grupo 834",
  transform: "translate(2.114 2.82)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2446",
  "data-name": "Caminho 2446",
  d: "M662.456,514.463l-3.652-3.652a.126.126,0,0,1,0-.177l7.033-7.033a.126.126,0,0,1,.177,0l3.652,3.652a.126.126,0,0,1,0,.177l-7.034,7.033A.125.125,0,0,1,662.456,514.463Zm-3.386-3.741,3.475,3.475,6.856-6.856-3.475-3.475Z",
  transform: "translate(-658.768 -503.564)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_835",
  "data-name": "Grupo 835",
  transform: "translate(8.941 0.858)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2447",
  "data-name": "Caminho 2447",
  d: "M682.461,504.387l-3.652-3.652a.126.126,0,0,1,0-.177l2.164-2.164a.125.125,0,0,1,.177,0l3.652,3.652a.125.125,0,0,1,0,.177l-2.164,2.164A.125.125,0,0,1,682.461,504.387Zm-3.386-3.74,3.475,3.475,1.987-1.987-3.474-3.475Z",
  transform: "translate(-678.773 -498.357)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_836",
  "data-name": "Grupo 836",
  transform: "translate(11.125)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2448",
  "data-name": "Caminho 2448",
  d: "M689.055,500.452l-3.607-3.607a.127.127,0,0,1,0-.18l.307-.307a1.945,1.945,0,0,1,2.667-.145l1.111,1.112a2.132,2.132,0,0,1,.009,2.821l-.308.307A.128.128,0,0,1,689.055,500.452Zm-3.337-3.7,3.427,3.427.217-.217a1.886,1.886,0,0,0-.009-2.46l-1.111-1.111a1.705,1.705,0,0,0-2.306.145Z",
  transform: "translate(-685.411 -495.75)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_837",
  "data-name": "Grupo 837",
  transform: "translate(9.407 1.294)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2449",
  "data-name": "Caminho 2449",
  d: "M683.878,504.809l-3.652-3.652a.126.126,0,0,1,0-.177l1.263-1.263a.125.125,0,0,1,.177,0l3.652,3.652a.126.126,0,0,1,0,.177l-1.263,1.262A.125.125,0,0,1,683.878,504.809Zm-3.387-3.74,3.475,3.475,1.085-1.085-3.474-3.475Z",
  transform: "translate(-680.189 -499.681)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_839",
  "data-name": "Grupo 839",
  transform: "translate(0 9.851)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2451",
  "data-name": "Caminho 2451",
  d: "M652.381,531.094a.127.127,0,0,1-.03-.133l2.111-5.944a.127.127,0,0,1,.21-.047l3.652,3.652a.126.126,0,0,1,.034.116.127.127,0,0,1-.078.093l-5.763,2.292a.128.128,0,0,1-.135-.026Zm2.254-5.8-1.95,5.488,5.322-2.116Z",
  transform: "translate(-652.344 -524.933)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_840",
  "data-name": "Grupo 840",
  transform: "translate(0.213 14.477)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2452",
  "data-name": "Caminho 2452",
  d: "M653.449,538.99l-.459,1.433,1.391-.5Z",
  transform: "translate(-652.99 -538.99)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEditCupom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_edit_cupom.606fbae6.svg";
export { ForwardRef as ReactComponent };